// Aquarius Lead-Free Portable Water Transport System Catalog
// HSN CODE: 39172390

export const aquariusCatalog = {
    page: 1,
    title: "ASTRAL AQUARIUS - LEAD-FREE PORTABLE WATER TRANSPORT SYSTEM",
    hsn_code: "39172390",
    description: "Lead-free pipes for potable water transport",
    sections: [
        {
            name: "PIPE SCHEDULE - 40 (3 METRE LENGTH)",
            length: "3m",
            schedule: "40",
            items: [
                { size_cm: "1.5", size_inch: "½", product_code: "M051400301", std_pkg: 30, price_inr_per_pc: 243.00 },
                { size_cm: "2.0", size_inch: "¾", product_code: "M051400302", std_pkg: 30, price_inr_per_pc: 309.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M051400303", std_pkg: 20, price_inr_per_pc: 462.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M051400304", std_pkg: 15, price_inr_per_pc: 651.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M051400305", std_pkg: 10, price_inr_per_pc: 948.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M051400306", std_pkg: 8, price_inr_per_pc: 1026.00 },
                { size_cm: "6.5", size_inch: "2½", product_code: "M051400307", std_pkg: 5, price_inr_per_pc: 1656.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M051400308", std_pkg: 3, price_inr_per_pc: 2238.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M051400309", std_pkg: 2, price_inr_per_pc: 3156.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M051400310", std_pkg: 1, price_inr_per_pc: 5781.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M051400311", std_pkg: 1, price_inr_per_pc: 9039.00 },
                { size_cm: "25.0", size_inch: "10", product_code: "M051400312", std_pkg: 1, price_inr_per_pc: 11916.00 },
                { size_cm: "30.0", size_inch: "12", product_code: "M051400313", std_pkg: 1, price_inr_per_pc: 18212.00 }
            ]
        },
        {
            name: "PIPE SCHEDULE - 40 (6 METRE LENGTH)",
            length: "6m",
            schedule: "40",
            items: [
                { size_cm: "1.5", size_inch: "½", product_code: "M051400601", std_pkg: 30, price_inr_per_pc: 446.00 },
                { size_cm: "2.0", size_inch: "¾", product_code: "M051400602", std_pkg: 20, price_inr_per_pc: 618.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M051400603", std_pkg: 15, price_inr_per_pc: 924.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M051400604", std_pkg: 10, price_inr_per_pc: 1302.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M051400605", std_pkg: 10, price_inr_per_pc: 1536.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M051400606", std_pkg: 6, price_inr_per_pc: 2052.00 },
                { size_cm: "6.5", size_inch: "2½", product_code: "M051400607", std_pkg: 5, price_inr_per_pc: 3312.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M051400608", std_pkg: 3, price_inr_per_pc: 4476.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M051400609", std_pkg: 2, price_inr_per_pc: 6312.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M051400610", std_pkg: 1, price_inr_per_pc: 11502.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M051400611", std_pkg: 1, price_inr_per_pc: 18078.00 },
                { size_cm: "25.0", size_inch: "10", product_code: "M051400612", std_pkg: 1, price_inr_per_pc: 23832.00 },
                { size_cm: "30.0", size_inch: "12", product_code: "M051400613", std_pkg: 1, price_inr_per_pc: 32424.00 }
            ]
        },
        {
            name: "PIPE SCHEDULE - 80 (3 METRE LENGTH)",
            length: "3m",
            schedule: "80",
            items: [
                { size_cm: "1.5", size_inch: "½", product_code: "M051800301", std_pkg: 50, price_inr_per_pc: 306.00 },
                { size_cm: "2.0", size_inch: "¾", product_code: "M051800302", std_pkg: 30, price_inr_per_pc: 414.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M051800303", std_pkg: 20, price_inr_per_pc: 603.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M051800304", std_pkg: 15, price_inr_per_pc: 831.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M051800305", std_pkg: 10, price_inr_per_pc: 1104.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M051800306", std_pkg: 8, price_inr_per_pc: 1395.00 },
                { size_cm: "6.5", size_inch: "2½", product_code: "M051800307", std_pkg: 5, price_inr_per_pc: 2160.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M051800308", std_pkg: 3, price_inr_per_pc: 2880.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M051800309", std_pkg: 2, price_inr_per_pc: 4190.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M051800310", std_pkg: 1, price_inr_per_pc: 8379.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M051800311", std_pkg: 1, price_inr_per_pc: 12591.00 },
                { size_cm: "25.0", size_inch: "10", product_code: "M051800312", std_pkg: 1, price_inr_per_pc: 18804.00 },
                { size_cm: "30.0", size_inch: "12", product_code: "M051800313", std_pkg: 1, price_inr_per_pc: 27154.00 }
            ]
        },
        {
            name: "PIPE SCHEDULE - 80 (6 METRE LENGTH)",
            length: "6m",
            schedule: "80",
            items: [
                { size_cm: "1.5", size_inch: "½", product_code: "M051800601", std_pkg: 30, price_inr_per_pc: 612.00 },
                { size_cm: "2.0", size_inch: "¾", product_code: "M051800602", std_pkg: 20, price_inr_per_pc: 828.00 },
                { size_cm: "2.5", size_inch: "1", product_code: "M051800603", std_pkg: 15, price_inr_per_pc: 1206.00 },
                { size_cm: "3.2", size_inch: "1¼", product_code: "M051800604", std_pkg: 10, price_inr_per_pc: 1662.00 },
                { size_cm: "4.0", size_inch: "1½", product_code: "M051800605", std_pkg: 10, price_inr_per_pc: 2028.00 },
                { size_cm: "5.0", size_inch: "2", product_code: "M051800606", std_pkg: 6, price_inr_per_pc: 2790.00 },
                { size_cm: "6.5", size_inch: "2½", product_code: "M051800607", std_pkg: 5, price_inr_per_pc: 4320.00 },
                { size_cm: "8.0", size_inch: "3", product_code: "M051800608", std_pkg: 3, price_inr_per_pc: 5760.00 },
                { size_cm: "10.0", size_inch: "4", product_code: "M051800609", std_pkg: 2, price_inr_per_pc: 8388.00 },
                { size_cm: "15.0", size_inch: "6", product_code: "M051800610", std_pkg: 1, price_inr_per_pc: 16758.00 },
                { size_cm: "20.0", size_inch: "8", product_code: "M051800611", std_pkg: 1, price_inr_per_pc: 25182.00 },
                { size_cm: "25.0", size_inch: "10", product_code: "M051800612", std_pkg: 1, price_inr_per_pc: 37608.00 },
                { size_cm: "30.0", size_inch: "12", product_code: "M051800613", std_pkg: 1, price_inr_per_pc: 54312.00 }
            ]
        }
    ]
};

// Helper function to format price in INR
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};

// Helper function to get all Aquarius products as flat array
export const getAllAquariusProducts = () => {
    const allProducts = [];
    aquariusCatalog.sections.forEach((section, sectionIndex) => {
        section.items.forEach((item, itemIndex) => {
            allProducts.push({
                id: `aquarius-${sectionIndex}-${itemIndex}`,
                ...item,
                sectionName: section.name,
                schedule: section.schedule,
                length: section.length,
                hsnCode: aquariusCatalog.hsn_code
            });
        });
    });
    return allProducts;
};

// Get unique schedules for filter
export const getAquariusSchedules = () => {
    return [...new Set(aquariusCatalog.sections.map(section => section.schedule))];
};

// Get unique lengths for filter
export const getAquariusLengths = () => {
    return [...new Set(aquariusCatalog.sections.map(section => section.length))];
};
